var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_import_file",
          attrs: {
            id: "modal-import-file",
            title: "Импорт заявок из файла",
            size: "md",
            "modal-class": "custom-modal",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            centered: ""
          },
          on: { hidden: _vm.hideModal },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100 d-flex justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-secondary mr-2",
                          on: { click: _vm.hideModal }
                        },
                        [_vm._v("\n          Отменить\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-primary",
                          attrs: { disabled: _vm.loading },
                          on: { click: _vm.importTasks }
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-icon", {
                            attrs: { name: "buttons/export", size: 12 }
                          }),
                          _vm._v("\n          Импортировать\n        ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "b-card",
            { staticClass: "custom-card" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Объект" } },
                [
                  _c("location-select", {
                    ref: "location_select",
                    attrs: { id: "input-location-select" },
                    on: { onSelect: _vm.onLocationChange }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                { attrs: { label: "Адрес объекта" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "input-start-address",
                      size: "sm",
                      type: "text",
                      placeholder: "Введите адрес объекта"
                    },
                    model: {
                      value: _vm.newItem.start_address,
                      callback: function($$v) {
                        _vm.$set(_vm.newItem, "start_address", $$v)
                      },
                      expression: "newItem.start_address"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Менеджер" } },
                        [
                          _c("user-select", {
                            ref: "user_select",
                            attrs: {
                              id: "input-user-select",
                              "is-disabled": _vm.newItem.location_id === 0
                            },
                            on: { onSelect: _vm.onSelectExecutor }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Руководитель" } },
                        [
                          _c("b-form-input", {
                            staticClass: "text-small",
                            attrs: {
                              size: "sm",
                              type: "text",
                              disabled: "",
                              value:
                                _vm.newItem.project_id != null
                                  ? _vm.newItem.project_name
                                  : "-"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                { attrs: { label: "Вид работ объекта" } },
                [
                  _c("location-works-select", {
                    ref: "location_works_select",
                    staticClass: "mb-3",
                    attrs: { id: "location-works-select" },
                    on: { onSelect: _vm.onLocationWorkSelect }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-list-group",
                { attrs: { horizontal: "" } },
                [
                  _c("b-form-file", {
                    attrs: {
                      size: "sm",
                      accept: ".xlsx, .xls",
                      "browse-text": "Выбрать",
                      placeholder: "Файл не выбран"
                    },
                    model: {
                      value: _vm.importFile,
                      callback: function($$v) {
                        _vm.importFile = $$v
                      },
                      expression: "importFile"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "danger" },
                      on: {
                        click: function($event) {
                          _vm.importFile = null
                        }
                      }
                    },
                    [_c("font-awesome-icon", { attrs: { icon: "times" } })],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-678dfab2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-678dfab2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/TasksImport.vue
// module id = null
// module chunks = 